import { apiCap } from '@gik/api';
import { useInkindSituations } from '@gik/api/situation/situation';
import { FetchProvider } from '@gik/core/components/DynamicComponent/FetchProvider';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import React from 'react';
import type { SamplePagesGridProps } from './SamplePagesGrid';
import { SamplePagesGrid, SamplePagesGridSkeleton } from './SamplePagesGrid';

function SamplePagesGridWithDataComp(props: SamplePagesGridProps) {
  const useFetch = () => {
    return useInkindSituations({ page: 1, perPage: apiCap });
  };

  return (
    <FetchProvider fetch={useFetch} loadingComponent={<SamplePagesGridSkeleton {...props} />}>
      {({ data }) => <SamplePagesGrid {...props} items={data} />}
    </FetchProvider>
  );
}

export const SamplePagesGridWithData = withComponentErrorBoundary(SamplePagesGridWithDataComp);
